<template lang='pug'>
.date-filter(:class='{ open, "has-filter" : hasFilter }')
	.display-text(v-if='showText') {{ displayText }}
	.arrow(@click='open = !open')
	date-dropdown(
		:range='true'
		:clearable='true'
		@range-changed='emitFilter'
		@clear='clear'
		@done='open = false'
	)
</template>

<script>
import DateDropdown from '@/components/DateDropdown';

import { dateOf } from '@/lib/time';

export default {
	name : 'date-filter',

	props : {
		showText : {
			type    : Boolean,
			default : false,
		},
		openFilter : {
			type : Boolean
		}
	},

	data : () => ( {
		open      : false,
		hasFilter : false,

		range : '',
	} ),

	computed : {

		displayText() {

			if ( !this.range || this.range === '' ) {
				return 'Select a date range';
			}

			if ( typeof this.range === 'string' ) {
				return dateOf( this.range );
			}

			if ( typeof this.range === 'object' ) {
				return `${dateOf( this.range.before )}-${dateOf( this.range.after )}`;
			}

			return 'Select a date range';

		},

	},

	watch : {
		open( open ) {
			if ( open ) {
				this.$emit( 'open' );
			}
		},
		openFilter( openFilter ) {
			if ( !openFilter ) {
				this.open = false;
			}
		}
	},

	methods : {

		emitFilter( range ) {
			this.hasFilter = ( range !== '' );

			this.range = range;

			this.$emit( 'filter', range );
		},

		clear() {
			this.open = false;
			this.emitFilter( '' );
		}

	},

	components : {
		DateDropdown,
	}
};
</script>

<style lang='scss'>
td:nth-last-child(1) .date-filter {
	width: 30px;
	padding-right: 15px;

	.date-dropdown {
		right: 0;
		transform: translateX(3px);
		left: unset;

		.arrow {
			left: 100%;
			transform: translate(calc(-100% + 7px),-100%);
		}
	}
}

.date-filter {
	position: relative;
	align-items: center;
	display: flex;
	justify-content: center;
	flex-flow: row nowrap;

	&.has-filter {

		> .arrow {
			transform: translateY(1px) scale(0.9,0.9);

			&::before,
			&::after {
				background: $color-primary;
			}
		}
	}

	&.open {

		.date-dropdown {
			opacity: 1;
			pointer-events: all;
		}

		&.has-filter > .arrow {
			transform: translateY(0px) scale(0.9,0.9);
			border: 2px solid $color-primary;
			border-radius: 50%;
		}

		> .arrow {
			transform: translateY(0px);

			&::before {
				transform: translate3d(3px, -50%, 0) rotate(45deg);
			}

			&::after {
				transform: translate3d(3px, -50%, 0) rotate(-45deg);
			}
		}
	}

	> .arrow {
		height: 20px;
		width: 20px;
		min-width: 20px;
    max-width: 20px;
		position: relative;
		cursor: pointer;
		transform: translateY(0);
		transition: transform 0.2s ease;

		&::before, &::after {
			content: ' ';
			height: 10px;
			width: 2px;
			background: $input-color;
			border-radius: 12px;
			right: calc(50% + 2px);
			position: absolute;
			transition: .2s ease-in-out;
			top: 50%;
			transform: translate3d( 0, -50%, 0 );
			z-index: 2;
		}

		&::before {
			transform: translate(6px, -50%) rotate(45deg);
		}

		&::after {
			transform: translate(0, -50%) rotate(-45deg);
		}
	}

	.display-text {
		color: $input-color-faded;
		margin-right: 10px;
		text-overflow: ellipsis;
		white-space: nowrap;
		position: relative;
		overflow: hidden;
		font-weight: 500;
	}

	.date-dropdown {
		opacity: 0;
		pointer-events: none;
		transform: opacity 0.2s ease;
		position: absolute;
		top: 34px;
		left: 50%;
		transform: translateX(-50%);
	}
}
</style>
